import { isNil } from 'lodash'

import { ResourceConfig } from '../types/resource'

/**
 * 从全部菜单项中过滤出侧边栏菜单项
 *
 * @param allResources 全部菜单项
 * @returns 侧边栏菜单项
 */
export const filterVisibleResources = (
  allResources: ResourceConfig[]
): ResourceConfig[] => {
  const visibleResources: ResourceConfig[] = []
  for (const { children, ...menu } of allResources) {
    if (menu.hideInMenu) {
      continue
    }
    if (menu.hideChildrenInMenu) {
      visibleResources.push(menu)
    } else {
      const newChildren = children && filterVisibleResources(children)
      // 没有子菜单且没有path，不显示
      if (!newChildren?.length && isNil(menu.path)) {
        continue
      }
      visibleResources.push({
        ...menu,
        children: newChildren
      })
    }
  }

  return visibleResources
}
